import { useState, useEffect } from "react";
import { notification, Form } from 'antd';
import axios from 'axios';
import { ResetPasswordUrl, VerifyTokenUrl } from '../utils/network';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from "../components/AuthLayout";
import AuthComponent from "../components/AuthComponent";

function ResetPassword() {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const history = useNavigate();
    const [searchParams] = useSearchParams();
    const tokenFromUrl = searchParams.get('token') || '';
    const initialEmail = searchParams.get('email') || '';
    const [email, setEmail] = useState(initialEmail);

    useEffect(() => {
        if (tokenFromUrl) {
            form.setFieldsValue({ token: tokenFromUrl });
            if (!email) {
                axios.get(`${VerifyTokenUrl}?token=${tokenFromUrl}`)
                    .then(res => {
                        if (res.data?.email) {
                            setEmail(res.data.email);
                        }
                    })
                    .catch(() => {});
            }
        }
    }, [searchParams, form, tokenFromUrl]);

    const onFinish = async (values: any) => {
        setLoading(true);
        try {
            const resetData = {
                password: values.password,
                token: values.token || tokenFromUrl
            };
            
            await axios.post(ResetPasswordUrl, resetData);
            notification.success({
                message: "Password Reset Successful",
                description: "Your password has been reset successfully."
            });
            history("/login"); 
        } catch (error: any) {
            notification.error({
                message: "Password Reset Error",
                description: error.response?.data?.error || "An error occurred while resetting your password."
            });
        }
        setLoading(false);
    };

    return (
        <AuthLayout>
            <AuthComponent
                form={form}
                titleText="Reset"
                titleSpanText="Password"
                subtitleText="Enter your new password below to complete the setup process"
                bottonText="Update Password"
                isPassword={true}
                isUpdatePassword={true}
                linkText="Back to Sign In"
                linkPath="/login"
                onSubmit={onFinish}
                loading={loading}
                initialValues={{ token: tokenFromUrl, email: email }}
                isEmailDisabled={!!tokenFromUrl || !!email}
            />
        </AuthLayout>
    );
}

export default ResetPassword;